import { render } from "./NotificationEditItemPane.vue?vue&type=template&id=086bb675&scoped=true&ts=true"
import script from "./NotificationEditItemPane.vue?vue&type=script&lang=ts"
export * from "./NotificationEditItemPane.vue?vue&type=script&lang=ts"

import "./NotificationEditItemPane.vue?vue&type=style&index=0&id=086bb675&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086bb675"]])

export default __exports__